/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface DeleteApplication200Response
 */
export interface DeleteApplication200Response {
  /**
   *
   * @type {boolean}
   * @memberof DeleteApplication200Response
   */
  status: boolean
  /**
   *
   * @type {Array<string>}
   * @memberof DeleteApplication200Response
   */
  data: Array<string>
}

/**
 * Check if a given object implements the DeleteApplication200Response interface.
 */
export function instanceOfDeleteApplication200Response(
  value: object
): value is DeleteApplication200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function DeleteApplication200ResponseFromJSON(
  json: any
): DeleteApplication200Response {
  return DeleteApplication200ResponseFromJSONTyped(json, false)
}

export function DeleteApplication200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DeleteApplication200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: json['data'],
  }
}

export function DeleteApplication200ResponseToJSON(
  value?: DeleteApplication200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: value['data'],
  }
}
